import { render, staticRenderFns } from "./ComposerMockPart.vue?vue&type=template&id=0bde202c&scoped=true"
import script from "./ComposerMockPart.vue?vue&type=script&lang=js"
export * from "./ComposerMockPart.vue?vue&type=script&lang=js"
import style0 from "./ComposerMockPart.vue?vue&type=style&index=0&id=0bde202c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde202c",
  null
  
)

export default component.exports